import script from "./ArrLookupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrLookupDialog.vue?vue&type=script&setup=true&lang=js"

import "./ArrLookupDialog.vue?vue&type=style&index=0&id=5d980efd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d980efd"]])

export default __exports__